<template>
  <v-dialog
    transition="dialog-bottom-transition"
    v-bind:content-class="_xsOnly() ? 'v-bottom-sheet' : ''"
    v-model="model"
    max-width="600px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-row
        :class="_isMobile() ? 'ma-0 pr-4' : 'pr-2 ma-0'"
        align="center"
        justify="end"
      >
        <v-btn
          width="24px"
          height="24px"
          :outlined="!_isMobile()"
          :color="_isMobile() ? 'white' : 'primary'"
          fab
          v-bind="attrs"
          v-on="on"
        >
          <v-icon size="16px">{{ mdiPlus }}</v-icon>
        </v-btn>
      </v-row>
    </template>
    <v-list style="width: 100%" class="pb-12">
      <v-row aling="center" justify="start" class="pa-0 ma-0 pl-2 pb-4">
        <v-btn
          x-small
          @click="model = false"
          text
          class="text-none primary--text"
          style="border: 0.5px solid rgba(242, 242, 242, 1)"
        >
          {{ _getLabel("CLOSE") }}
        </v-btn>
      </v-row>
      <v-list-item
        @click="
          () => {
            postFavorites();
            model = false;
          }
        "
        v-if="hasFavoritesOption"
      >
        <v-list-item-avatar class="ma-0 pa-0 mr-4">
          <v-avatar size="20px" tile>
            <v-icon color="primary">{{ mdiBookmarkOutline }}</v-icon>
          </v-avatar>
        </v-list-item-avatar>
        <v-list-item-title class="text-left">{{
          _getLabel("FAVORITE")
        }}</v-list-item-title>
        <v-list-item-action>
          <v-icon small color="primary">
            {{ mdiChevronRight }}
          </v-icon>
        </v-list-item-action>
      </v-list-item>
      <v-divider v-if="hasFavoritesOption"></v-divider>
      <v-list-item
        @click="
          () => {
            contactUs();
            model = false;
          }
        "
      >
        <v-list-item-avatar class="ma-0 pa-0 mr-4">
          <v-avatar size="18px" tile>
            <v-icon color="primary">{{ _icon("support") }}</v-icon>
          </v-avatar>
        </v-list-item-avatar>
        <v-list-item-title class="text-left">{{
          _getLabel("USER_SECTION_CONTACT_US")
        }}</v-list-item-title>
        <v-list-item-action>
          <v-icon small color="primary">
            {{ mdiChevronRight }}
          </v-icon>
        </v-list-item-action>
      </v-list-item>
      <v-divider></v-divider>
      <v-list-item
        @click="
          () => {
            share();
            model = false;
          }
        "
      >
        <v-list-item-avatar class="ma-0 pa-0 mr-4">
          <v-avatar size="22px" tile>
            <v-icon color="primary">{{ mdiShareOutline }}</v-icon>
          </v-avatar>
        </v-list-item-avatar>
        <v-list-item-title class="text-left">{{
          _getLabel("SHARE")
        }}</v-list-item-title>
        <v-list-item-action>
          <v-icon small color="primary">
            {{ mdiChevronRight }}
          </v-icon>
        </v-list-item-action>
      </v-list-item>
    </v-list>
  </v-dialog>
</template>

<script>
import {
  mdiPlus,
  mdiChevronRight,
  mdiShareOutline,
  mdiBookmarkOutline,
} from "@mdi/js";
import { mapMutations, mapActions } from "vuex";
export default {
  name: "HeaderOptions",
  methods: {
    ...mapActions("general", ["copyToClipboard", "logEvent", "contactUs"]),
    ...mapActions("preferences", ["postFavorites"]),
    share() {
      this.logEvent("share", { url: this.shareObj.url });
      this.copyToClipboard(this.shareObj.url);
    },
    buildShareObject(deepLinkUrl) {
      if (this._isMobile() && !this._isAndroid()) {
        return {
          title: this._getMessage("SHARE_TITLE"),
          text: deepLinkUrl,
          url: deepLinkUrl,
        };
      }
      return {
        title: this._getMessage("SHARE_TITLE"),
        text: this._getMessage("SHARE_TEXT"),
        url: deepLinkUrl,
      };
    },
  },
  computed: {
    hasFavoritesOption() {
      return this.$route.meta.favorites;
    },
    shareObj: function () {
      const baseUrl = `https://app.vetalfa.com/#${this.$route.fullPath}`;
      return this.buildShareObject(baseUrl);
    },
  },
  data() {
    return {
      model: false,
      mdiPlus,
      mdiChevronRight,
      mdiShareOutline,
      mdiBookmarkOutline,
    };
  },
};
</script>
